import React from 'react';
import '../styles.css';
import { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { PAGES } from '../constants/Pages';
import { LogoSVG } from '../component/utils/logoSvg';
import { getUserFromLocalStorage } from '../component/utils/user';
import { MESSAGE } from '../constants/Message';
import { getMessage } from '../translations';
import Button from '@mui/material/Button';
import HeadsetMicIcon from '@mui/icons-material/HeadsetMic';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import MoveUpIcon from '@mui/icons-material/MoveUp';
import TableChartIcon from '@mui/icons-material/TableChart';
import AutoAwesomeMotionIcon from '@mui/icons-material/AutoAwesomeMotion';
import Tooltip from '@mui/material/Tooltip';

const Header = () => {
  const location = useLocation();
  const localUser = getUserFromLocalStorage();
  const initials = localUser.firstName.charAt(0) + localUser.lastName.charAt(0);
  const [userEmail, setUserEmail] = useState(localUser.email);
  const [confirmationOpen, setConfirmationOpen] = useState(false);

  const handleLogOut = async () => {
    try {
      await logoutUser();
      window.location.href = '/';
    } catch (error) {
      console.error(error);
    }
    return false;
  };

  const logoutUser = async () => {
    localStorage.removeItem('TOKEN');
    localStorage.removeItem('ISLOGIN');
    localStorage.removeItem('EMAIL');
  };

  const checkActiveMenu = ($menuPath) => {
    var isActiveClass = '';
    if (
      location.pathname === $menuPath ||
      location.pathname === `${$menuPath}/`
    ) {
      isActiveClass = 'active';
    }
    return isActiveClass;
  };

  let headingText = '';

  if (location.pathname === '/TransportScreen') {
    headingText = 'Rate Management - Local';
  } else if (
    location.pathname === '/FreightScreen' ||
    location.pathname === '/TransportAllRateScreen'
  ) {
    headingText = 'Rate Management - Export';
  } else if (location.pathname === '/UploaderScreen') {
    headingText = 'Logistics';
  } else if (location.pathname === '/ContractScreen') {
    headingText = 'Contract renewal';
  } else if (location.pathname === '/MasterScreen') {
    headingText = 'Master import';
  } else if (location.pathname === '/TransactionalScreen') {
    headingText = 'Trasanctional data import';
  }

  useEffect(() => {
    if (!userEmail) {
      window.location.href = '/404';
    }
  }, [userEmail]);

  const handleDownload = () => {
    const filePath = process.env.REACT_APP_EXCL_TEMPLATE_URL;
    const a = document.createElement('a');
    a.href = filePath;
    a.download = '';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };
  const handleNavigateWeb = () => {
    window.open(`${process.env.REACT_APP_SUPPORT_URL}`, '_blank');
  };

  const [isOpen, setIsOpen] = useState(false);
  const [isLogisticMenuOpen, setIsLogisticMenuOpen] = useState(false);
  const dropdownRef = useRef(null);
  const logisticDropdownRef = useRef(null);
  const toggleLogisticMenu = () => {
    setIsLogisticMenuOpen(!isLogisticMenuOpen);
  };
  const toggleSubMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
    if (
      logisticDropdownRef.current &&
      !logisticDropdownRef.current.contains(event.target)
    ) {
      setIsLogisticMenuOpen(false);
    }
  };
  const handleConfirmBoxOpen = () => {
    // Open the confirmation dialog
    setConfirmationOpen(true);
  };
  const handleConfirm = async () => {
    setConfirmationOpen(false);
    handleDownload();
  };
  const handleCancel = () => {
    setConfirmationOpen(false);
  };
  useEffect(() => {
    // Added click event listener to the document to close the menu when clicked outside
    document.addEventListener('click', handleClickOutside);
    // Clean up the event listener when the component unmounts
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);
  return (
    <>
      <header id='header'>
        <div id='hidden-mobile' className='container columns full screen'>
          <div className='wrapper'>
            <div
              className='inner'
              data-onvisible-trigger='1'
              style={{ opacity: 1 }}
            >
              <div className='DflexCenter'>
                <div className='logoBox'>
                  <Link
                    to={`/${PAGES.UPLOADERSCREEN}`}
                    style={{ cursor: 'pointer' }}
                  >
                    <LogoSVG />
                  </Link>
                  {process.env.REACT_APP_ENV !== 'Prod' ? (
                    <>
                      <i className='envInitails'>{process.env.REACT_APP_ENV}</i>
                      <p className='seprator-st'></p>
                    </>
                  ) : (
                    <></>
                  )}

                  <p className='heading-scren-text'>{headingText}</p>
                </div>
              </div>
              <div>
                <ul id='links03' className='links'>
                  <li className='n02'>
                    <Tooltip
                      title={getMessage('Logistics')}
                      placement='top'
                      PopperProps={{
                        modifiers: [
                          {
                            name: 'offset',
                            options: {
                              offset: [0, -3], // Adjust this value as needed
                            },
                          },
                        ],
                      }}
                    >
                      <Link
                        // style={{ cursor: 'not-allowed' }}
                        to={`/${PAGES.UPLOADERSCREEN}`}
                        className={checkActiveMenu('/UploaderScreen')}
                      >
                        {/* {getMessage('Logistics')} */}
                        <HeadsetMicIcon />
                      </Link>
                    </Tooltip>
                  </li>
                  <li
                    className={`n02 header-dropdown ${
                      isLogisticMenuOpen ? 'active' : ''
                    }`}
                    onClick={toggleLogisticMenu}
                    ref={logisticDropdownRef}
                  >
                    <Tooltip
                      className='pos-option'
                      title={getMessage('Logistic rates')}
                      placement='top'
                      PopperProps={{
                        modifiers: [
                          {
                            name: 'offset',
                            options: {
                              offset: [0, -3], // Adjust this value as needed
                            },
                          },
                        ],
                      }}
                    >
                      <Link className='resource-option'>
                        <LocalShippingIcon />
                      </Link>
                    </Tooltip>
                    <div className='dropdown-content'>
                      <div className='resource-option local-menu'>
                        {getMessage('Export')}
                      </div>
                      <hr className='menu-divider' />
                      <Link
                        to={`/${PAGES.FREIGHTSCREEN}`}
                        className='resource-option'
                      >
                        {getMessage('FREIGHT_HEADER')}
                      </Link>
                      <Link
                        to={`/${PAGES.TRANSPORTALLRATESCREEN}`}
                        className='resource-option beta-menu'
                      >
                        {getMessage('Transport All In Rate')}
                        <span className='beta-label'>Beta</span>
                      </Link>
                      <div className='resource-option local-menu'>
                        {getMessage('Local')}
                      </div>
                      <hr className='menu-divider' />
                      <Link
                        to={`/${PAGES.TRANSPORTSCREEN}`}
                        className='resource-option'
                      >
                        {getMessage('Transport Rate')}
                      </Link>
                    </div>
                  </li>
                  {localUser.email.endsWith('@julesai.com') ? (
                    <>
                      <li className='n02'>
                        <Tooltip
                          className='pos-option'
                          title={getMessage('MASTER_HEADER')}
                          placement='top'
                          PopperProps={{
                            modifiers: [
                              {
                                name: 'offset',
                                options: {
                                  offset: [0, -3], // Adjust this value as needed
                                },
                              },
                            ],
                          }}
                        >
                          <Link
                            // style={{ cursor: 'not-allowed' }}
                            to={`/${PAGES.MASTERSCREEN}`}
                            className={checkActiveMenu('/MasterScreen')}
                          >
                            {/* {getMessage('MASTER_HEADER')} */}
                            <TableChartIcon />
                          </Link>
                        </Tooltip>
                      </li>
                      <li className='n02'>
                        <Tooltip
                          className='pos-option'
                          title={getMessage('Transactional import')}
                          placement='top'
                          PopperProps={{
                            modifiers: [
                              {
                                name: 'offset',
                                options: {
                                  offset: [0, -3], // Adjust this value as needed
                                },
                              },
                            ],
                          }}
                        >
                          <Link
                            // style={{ cursor: 'not-allowed' }}
                            to={`/${PAGES.TRANSACTIONALSCREEN}`}
                            className={checkActiveMenu('/TransactionalScreen')}
                          >
                            {/* {getMessage('MASTER_HEADER')} */}
                            <AutoAwesomeMotionIcon />
                          </Link>
                        </Tooltip>
                      </li>
                      <li className='n02'>
                        <Tooltip
                          className='pos-option'
                          title={getMessage('CONTRACT_RENEWAL_HEADER')}
                          placement='top'
                          PopperProps={{
                            modifiers: [
                              {
                                name: 'offset',
                                options: {
                                  offset: [0, -3], // Adjust this value as needed
                                },
                              },
                            ],
                          }}
                        >
                          <Link
                            to={`/${PAGES.CONTRACTSCREEN}`}
                            className={checkActiveMenu('/ContractScreen')}
                          >
                            {/* {getMessage('CONTRACT_RENEWAL_HEADER')} */}
                            <MoveUpIcon />
                          </Link>
                        </Tooltip>
                      </li>
                    </>
                  ) : (
                    <></>
                  )}
                  <li
                    className={`n02 header-dropdown ${isOpen ? 'active' : ''}`}
                    onClick={toggleSubMenu}
                    ref={dropdownRef}
                  >
                    <i className='userNInitails'>{initials}</i>
                    <div className='dropdown-content'>
                      <Link
                        onClick={handleConfirmBoxOpen}
                        className='resource-option'
                      >
                        {getMessage('SAMPLE_TEMPLATE')}
                      </Link>
                      <Link
                        onClick={handleNavigateWeb}
                        className='resource-option'
                      >
                        {getMessage('SUPPORT_HELP')}
                      </Link>
                      <Link
                        style={{ cursor: 'pointer' }}
                        className='resource-option'
                        onClick={handleLogOut}
                      >
                        {getMessage('LOGOUT')}
                      </Link>
                    </div>
                  </li>
                </ul>
              </div>
              {confirmationOpen && (
                <div className='overlay-box'>
                  <div className='confirmation-dialog popup'>
                    <a
                      className='close'
                      onClick={() => {
                        setConfirmationOpen(false);
                      }}
                    >
                      <svg
                        className='sc-gsnTZi GjRDn MuiSvgIcon-root MuiSvgIcon-fontSizeMedium'
                        focusable='false'
                        viewBox='0 0 24 24'
                        aria-hidden='true'
                        data-testid='CloseIcon'
                      >
                        <path
                          d='M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 
                6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'
                        ></path>
                      </svg>
                    </a>
                    <h4>{getMessage('CONFIRMATION_TEXT_SAMPLE_DOC')}</h4>
                    <div className='btnSectionConfBx'>
                      <Button variant='contained' onClick={handleConfirm}>
                        {getMessage('CONFIRMATION_CONTINUE')}
                      </Button>

                      <Button variant='contained' onClick={handleCancel}>
                        {getMessage('CONFIRMATION_CANCEL')}
                      </Button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </header>
    </>
  );
};
export default Header;